import { createTheme } from '@mui/material';


const theme = createTheme({
    palette: {
        type: "dark",
    },
});

export default theme;